import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { ApplicationState } from "../../store";
import * as httpClient from "../../util/httpClient";
import * as MyAccountActions from "../../store/myAccount/actions";

const securityQuestionAnswer = [
    { label: "Security Question 1", que: 0 },
    { label: "Security Question 2", que: 1 },
    { label: "Security Question 3", que: 2 },
];

const DashboardSecurityQuestionDialog = (props: any) => {
    const dispatch = useDispatch();
    const { register, handleSubmit, errors } = useForm({
        mode: "onTouched",
        criteriaMode: "all",
    });
    const partnerPhone = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : "1-888-439-7443"
    );
    const [isLoading, setIsLoading] = useState(false);
    const [securityQue, setSecurityQue] = useState<any>(props.securityQueData.securityQuestionList);
    let userData = useSelector((state: ApplicationState) => {
        let data: any = {
            email: "",
            isIDFUser: false,
            isSuccess: true,
            securityQuestionsCount: 3,
            portalName: "",
        };
        if (state.configurationState && state.configurationState.configuration && state.configurationState.configuration.partnerConfig != null) {
            data.portalName = state.configurationState.configuration.partnerConfig.partnerProvider;
        }

        if (state.loggedInUser && state.loggedInUser.userInfo) {
            data.email = state.loggedInUser?.userInfo?.EmailAddress;
        }
        if (state.csidUserStatusState && state.csidUserStatusState.csidUserStatus) {
            data.isIDFUser = state.csidUserStatusState.csidUserStatus.isIDFUser;
        }

        return data;
    });

    const handleQusSelect = (qusId: any, index: any) => {
        let newSeqQus = securityQue.map((qus: any) => {
            let newQus = qus;

            if (qus.selectedIndex === index) {
                newQus = { ...qus };
                delete newQus.selected;
                delete newQus.selectedIndex;
            }
            if (qus.id === parseInt(qusId)) {
                newQus = { ...qus };
                newQus["selected"] = true;
                newQus["selectedIndex"] = index;
            }
            return newQus;
        });
        setSecurityQue(newSeqQus);
    };
    const onSubmit = (data: any) => {
        setIsLoading(true);

        data.item.forEach((item: any) => {
            item.Id = parseInt(item.Id);
            const selectedQuestion: any = securityQue.filter((que: any) => item.Id === que.id)[0];
            item.question = selectedQuestion.question;
        });
        let reqBody = {
            securityQuestionAnswer: data.item,
            portalName: userData.portalName,
        };

        httpClient
            .sendRequest("POST", "api/security-question/save-security-questions", reqBody)
            .then((res) => {
                if (!res.isSuccess) {
                    setIsLoading(false);
                }
                dispatch(MyAccountActions.actionCreators.getSecurityQuestions());
                props.onClose();
            })
            .catch((err) => {
                setIsLoading(false);
            });
    };

    const renderSecurityQuestions = (item: { label: string; que: number }, index: number) => {
        const answerIndex = "answer" + (index + 1);

        return (
            <React.Fragment key={index}>
                <div className="form-row">
                    <div>
                        <legend className="legend-label" id={`label-security-question-${index}`}>
                            {" "}
                            {item.label}
                        </legend>
                    </div>

                    <div className="form-input">
                        <select
                            className="inputbox"
                            id={`select-security-question-${index}`}
                            name={`item[${index}].Id`}
                            ref={register({ required: true })}
                            onChange={(e) => handleQusSelect(e.target.value, index)}
                        >
                            <option value="">--- Choose a Question ---</option>
                            {securityQue &&
                                securityQue.length > 0 &&
                                securityQue.map((val: any) => {
                                    return (
                                        <option key={val.id} value={val.id} disabled={val.selected && val.selectedIndex !== index}>
                                            {val.question}
                                        </option>
                                    );
                                })}
                        </select>
                        {errors &&
                            errors["item"] &&
                            errors["item"][index] &&
                            errors["item"][index]["Id"] &&
                            errors["item"][index]["Id"].types &&
                            errors["item"][index]["Id"].types.required === true && (
                                <span className="form-error">Please choose one of the given security questions.</span>
                            )}
                    </div>
                </div>

                <div className="form-row">
                    <div>
                        <legend className="legend-label" id={`label-security-question-${index}`}>
                            Answer
                        </legend>
                    </div>

                    <div className="form-input">
                        <input
                            type="text"
                            className={errors[answerIndex] ? "status-error inputbox" : "inputbox"}
                            name={`item[${index}].answer`}
                            id={`label-security-question-${index}-answer`}
                            ref={register({
                                required: true,
                                minLength: 4,
                            })}
                        />
                        {errors["item"] &&
                            errors["item"][index] &&
                            errors["item"][index]["answer"] &&
                            errors["item"][index]["answer"].types &&
                            errors["item"][index]["answer"].types.required === true && <span className="form-error">Answer is required.</span>}
                        {errors["item"] &&
                            errors["item"][index] &&
                            errors["item"][index]["answer"] &&
                            errors["item"][index]["answer"].types &&
                            errors["item"][index]["answer"].types.minLength && <span className="form-error">Answer must have at least four letters</span>}
                    </div>
                </div>
            </React.Fragment>
        );
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <h3>Choose security questions</h3>
                <p>The security questions below may be used to verify your identity in the future if you need assistance.</p>
            </div>
            <div className={isLoading ? "dialog-body loading" : "dialog-body"}>
                <div id="security-questions-form" aria-hidden="false">
                    <form id="security-questions-form-container" onSubmit={handleSubmit(onSubmit)}>
                        {securityQuestionAnswer.map((val, index) => renderSecurityQuestions(val, index))}
                        <div className="margin-vertical-l"></div>

                        <div className="dialog-footer text-align-center">
                            <button type="submit" className="btn-default btn-primary btn-min-width">
                                <span className="btn-text">Submit</span>
                            </button>
                        </div>
                        <div style={{ marginTop: "8px" }} className=" text-align-center">
                            <h5>Need Help? Call us at</h5>
                            <a href={'tel:"' + partnerPhone + '"'}>{partnerPhone}</a>
                        </div>
                    </form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default DashboardSecurityQuestionDialog;
